const REGISTER_CONFIRMED_PAGE = {
  title: 'Cadastro efetuado com sucesso!',
  text: 'Recebemos seu cadastro e você já está na nossa fila de espera. Analisamos a necessidade de novas parcerias por região, então pode levar um tempinho, ok?!',
  nextStepsTitle: 'Próximos passos',
  followStatus: 'Você pode acompanhar o status do seu cadastro pelo',
  seuZe: 'Seu zé',
  backToHome: 'Voltar para home',
  imgs: {
    ze: 'Logo do Zé Delivery de bebidas',
    success:
      'Ilustração com duas mãos brindando, a esquerda segurando um celular e a direita segurando uma garrafa',
  },
  acessibility: {
    backToHome: 'Página com informações da parceria',
  },
}

export default REGISTER_CONFIRMED_PAGE
